<!-- 车位周转数据 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "../../../commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCodeList": ["2KKN885S"]
            },
            responseCode: {

                }
                ,infoData: {
                explain: "第三方接入系统请求智慧停车开放平台 交易总览数据(港澳)-版本2",
                t_url: this.commonUrls.test+"dealSummariseForHKAndMacaoVer2",
                p_url: this.commonUrls.prod+"dealSummariseForHKAndMacaoVer2",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCodeList', info2: '是', info3: 'List', info4: '车场编码列表' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'yesterdayTransactionAmount', info2: '否', info3: 'BigDecimal', info4: '昨日交易金额' },
                        { info1: 'yesterdayTransactionAmountStr', info2: '否', info3: 'String', info4: '昨日交易金额（以万形式显示）' },
                        { info1: 'yesterdayTransactionNumber', info2: '否', info3: 'long', info4: '昨日交易次数' },
                        { info1: 'yesterdayTransactionNumberStr', info2: '否', info3: 'String', info4: '昨日交易次数（以万形式显示）' },
                        { info1: 'transactionAmount', info2: '否', info3: 'Integer', info4: '年度交易金额' },
                        { info1: 'transactionAmountStr', info2: '否', info3: 'String', info4: '年度交易金额（以万形式显示）' },
                        { info1: 'transactionNumber', info2: '否', info3: 'long', info4: '年度交易次数' },
                        { info1: 'transactionNumberStr', info2: '否', info3: 'String', info4: '年度交易次数（以万形式显示）' },
                        { info1: 'onlineNumber', info2: '否', info3: 'long', info4: '线上交易次数' },
                        { info1: 'onlineNumberPrecent', info2: '否', info3: 'Integer', info4: '线上交易次数占比' },
                        { info1: 'offlineNumber', info2: '否', info3: 'long', info4: '线下交易次数' },
                        { info1: 'offlineNumberPrecent', info2: '否', info3: 'Integer', info4: '线下交易次数占比' },
                        { info1: 'alipayNumber', info2: '否', info3: 'long', info4: '支付宝交易次数' },
                        { info1: 'alipayNumberPrecent', info2: '否', info3: 'Integer', info4: '支付宝交易次数占比' },
                        { info1: 'wechatNumber', info2: '否', info3: 'long', info4: '微信交易次数' },
                        { info1: 'wechatNumberPrecent', info2: '否', info3: 'Integer', info4: '微信交易次数占比' },
                        { info1: 'etcNumber', info2: '否', info3: 'long', info4: 'ETC交易次数' },
                        { info1: 'ectNumberPrecent', info2: '否', info3: 'Integer', info4: 'ETC交易次数占比' },
                        { info1: 'otherNumber', info2: '否', info3: 'long', info4: '其他交易次数' },
                        { info1: 'otherNumberPrecent', info2: '否', info3: 'Integer', info4: '其他交易次数占比' },
                        { info1: 'yesterdayInlandTransactionAmount', info2: '否', info3: 'Integer', info4: '昨日交易金额' },
                        { info1: 'yesterdayInlandTransactionAmountStr', info2: '否', info3: 'Integer', info4: '昨日交易金额' },
                        { info1: 'yesterdayInlandTransactionNumber', info2: '否', info3: 'long', info4: '昨日交易次数' },
                        { info1: 'yesterdayInlandTransactionNumberStr', info2: '否', info3: 'String', info4: '昨日交易次数（以万形式显示）' },
                        { info1: 'inlandTransactionAmount', info2: '否', info3: 'Integer', info4: '年度交易金额' },
                        { info1: 'inlandTransactionAmountStr', info2: '否', info3: 'String', info4: '年度交易金额（以万形式显示）' },
                        { info1: 'inlandTransactionNumber', info2: '否', info3: 'long', info4: '年度交易次数' },
                        { info1: 'inlandTransactionNumberStr', info2: '否', info3: 'String', info4: '年度交易次数（以万形式显示）' },
                        { info1: 'inlandNumber', info2: '否', info3: 'long', info4: '内地交易次数' },
                        { info1: 'inlandNumberPrecent', info2: '否', info3: 'Integer', info4: '内地交易占比' },
                        { info1: 'yesterdayHKAndMACAOTransactionAmount', info2: '否', info3: 'Integer', info4: '昨日交易金额' },
                        { info1: 'yesterdayHKAndMACAOTransactionAmountStr', info2: '否', info3: 'String', info4: '昨日交易金额（以万形式显示）' },
                        { info1: 'yesterdayHKAndMACAOTransactionNumber', info2: '否', info3: 'long', info4: '昨日交易次数' },
                        { info1: 'yHKAndMACAOTransactionAmount', info2: '否', info3: 'String', info4: '年度交易金额' },
                        { info1: 'yHKAndMACAOTransactionAmountStr', info2: '否', info3: 'String', info4: '年度交易金额（以万形式显示）' },
                        { info1: 'yHKAndMACAOTransactionNumber', info2: '否', info3: 'long', info4: '年度交易次数' },
                        { info1: 'yHKAndMACAOTransactionNumberStr', info2: '否', info3: 'String', info4: '年度交易次数（以万形式显示）' },
                        { info1: 'yHKAndMACAONumber', info2: '否', info3: 'long', info4: '港澳交易次数' },
                        { info1: 'yHKAndMACAONumberPrecent', info2: '否', info3: 'String', info4: '港澳交易占比' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/dataAnalysis/dealSummariseForHKAndMacaoVer2.vue